module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.538a2708.png";